<!--
  Skip targets live under router-outlet. Plain href="#id" + <base href="/"> often navigates to /#id and reloads the SPA.
  We keep href for semantics/SEO but handle activation in TS (preventDefault + scroll + focus).
-->
<nav class="app-skip-links" [attr.aria-label]="skipNavLabel">
  <a
    #firstSkipLink
    href="#main-content"
    class="app-skip-link"
    (click)="onSkipLinkClick($event, 'main-content')"
    (keydown.space)="onSkipLinkSpace($event, 'main-content')"
    >{{ skipMain }}</a
  >
  <a
    href="#main-nav"
    class="app-skip-link"
    (click)="onSkipLinkClick($event, 'main-nav')"
    (keydown.space)="onSkipLinkSpace($event, 'main-nav')"
    >{{ skipTop }}</a
  >
  <a
    href="#side-navigation"
    class="app-skip-link"
    (click)="onSkipLinkClick($event, 'side-navigation')"
    (keydown.space)="onSkipLinkSpace($event, 'side-navigation')"
    >{{ skipSide }}</a
  >
</nav>
<router-outlet />
